<template>
  <div v-if="note" class="font-weight-bold metric-yellow">
    {{ note }}
  </div>
</template>

<script>
export default {
  name: "StickyNote",
  props: {
    note: {
      type: String,
      required: false,
    },
  },
};
</script>
